import { colors, typographyCss } from '@creditornot/cb-ingredients';
import { Spinner } from '@creditornot/cb-progress';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  max-width: 210px;
`;

const LoaderTitle = styled.span`
  font-size: ${typographyCss.Heading5()};
`;

const LoaderDescription = styled.span`
  ${typographyCss.Body3()}
  text-align: center;
`;

export const Root = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  background-color: ${cssThemedValue({
    light: colors.salt100,
    dark: colors.space100,
  })};
`;

type Props = {
  children: ReactNode;
};

export const LoadingOverlay = ({ children }: Props) => {
  return (
    <Root>
      <LoaderContainer>
        <Spinner size="large" />
        <LoaderTitle>
          <FormattedMessage id="compliance.kyb.loader-title" />
        </LoaderTitle>
        <LoaderDescription>{children}</LoaderDescription>
      </LoaderContainer>
    </Root>
  );
};
